import { render, staticRenderFns } from "./AddNotificationBlogs.vue?vue&type=template&id=4f6b7774&"
import script from "./AddNotificationBlogs.vue?vue&type=script&lang=js&"
export * from "./AddNotificationBlogs.vue?vue&type=script&lang=js&"
import style0 from "./AddNotificationBlogs.vue?vue&type=style&index=0&id=4f6b7774&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports